import React from "react";
import { getApi } from '../../api/endpoints';
import PageUiActionConstants from '../../data/PageUiActionConstants';
import ListingComponent from '../../components/ListingComponent';
import { useParams } from "react-router-dom";

const Challans = () => {
  const defaultHeaderConfig = { disableSort: true };
  const params = useParams();
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer ID',
      attr: 'customer_id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Challan Amount',
      attr: 'amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Created Date and Time',
      attr: 'created_at',
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
    },
    {
      ...defaultHeaderConfig,
      label: 'Challan Reason',
      attr: 'reason',
    },
  ]
  const filters = { customer_id: params.id }

  return <>
    <ListingComponent
      key={PageUiActionConstants.view_customer_challans.name}
      listingMutation={getApi('challans')}
      className="customer_challans_listing-page"
      contentHeading="Challans - Results"
      headers={headers}
      recordsKey="challans"
      filtersModel={ filters }
      searchBy={['Customer ID']}
    />
  </>
};

export default Challans;






